<template lang="pug">
div.d-flex.detail-area
    div
    v-toolbar(
        color="teal darken-2"
        dark
        height="45"
        )
        span.title DETALLE VENTA
    v-card.scroll(max-height="250")
        v-layout
            v-flex.resize
                detail-header
                template(v-for="(item, idx) in items" )
                    item-strip.white(
                        :value="items[idx]"
                        @input="itemChangeHandler(idx, $event)"
                        
                        @action="$event(items, idx)"
                        :key="item.id"
                        
                        enableEditQuantity=false
                    )
</template>

<script>
import ItemStrip from '@/components/ItemStrip/ItemStrip'
import CartHeaders from '@/components/CashDesk/Detail/CartHeaders'
import { mapState } from 'vuex'
export default {
    name: 'detail',
    props: {},
    data: function(){
        return {}
    },
    computed: {
        ...mapState('CashDeskModule',{
            items : 'saleDetail'
        }),
    },
    methods: {},
    watch: {},
    components: {
        'item-strip' : ItemStrip,
        'detail-header':CartHeaders
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    .addBorder{
        border: solid black 2px; 
    }
    .scroll{
        overflow-y:auto;
    }
    .resize{
        font-size:10px !important;
    }
    .detail-area{
        flex-direction: column;
        justify-content: end;
    }
</style>